import { withIcon } from './withIcon';

const AddIconSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 28 28"
    fill="none"
  >
    <rect x="7" y="7" width="14" height="14" fill="white" />
    <path
      d="M14 3.5C8.21007 3.5 3.5 8.21007 3.5 14C3.5 19.7899 8.21007 24.5 14 24.5C19.7899 24.5 24.5 19.7899 24.5 14C24.5 8.21007 19.7899 3.5 14 3.5ZM18.5937 14.875H14.875V18.5937C14.875 19.0769 14.4831 19.4687 14 19.4687C13.5169 19.4687 13.1251 19.0769 13.1251 18.5937V14.875H9.40625C8.9232 14.875 8.5313 14.4831 8.5313 14C8.5313 13.5169 8.9232 13.1251 9.40625 13.1251H13.1251V9.40625C13.1251 8.9232 13.5169 8.5313 14 8.5313C14.4831 8.5313 14.875 8.9232 14.875 9.40625V13.1251H18.5937C19.0769 13.1251 19.4687 13.5169 19.4687 14C19.4687 14.4831 19.0769 14.875 18.5937 14.875Z"
      fill="#393946"
    />
  </svg>
);
export const AddIcon = withIcon(AddIconSVG);
